import {
  GALLERY_GRID_GAP, GALLERY_TARGET_TILE_WIDTH, GALLERY_MAX_COLUMNS,
} from "../../Constants/constantValues";

function emptySlotsInLastRow(count, columns) {
  return columns * Math.ceil(count / columns) - count;
}

export function calculateGalleryColumns(count, width, height) {
  if (count <= 4) return 2;

  if (!width || !height) return Math.min(4, count);

  const columnsFromWidth = Math.max(
    1,
    Math.min(
      GALLERY_MAX_COLUMNS,
      Math.floor((width + GALLERY_GRID_GAP) / (GALLERY_TARGET_TILE_WIDTH + GALLERY_GRID_GAP))
    )
  );

  const minColumns = Math.min(2, columnsFromWidth);
  const maxColumns = Math.max(minColumns, Math.min(columnsFromWidth, count - 1));

  const aspectColumns = Math.ceil(Math.sqrt(count * (width / height)));
  const idealColumns = Math.min(maxColumns, Math.max(minColumns, aspectColumns));

  let bestColumns = idealColumns;
  let bestEmptySlots = emptySlotsInLastRow(count, idealColumns);

  for (
    let columns = Math.max(minColumns, idealColumns - 1);
    columns <= Math.min(maxColumns, idealColumns + 1);
    columns++
  ) {
    const emptySlots = emptySlotsInLastRow(count, columns);
    if (emptySlots < bestEmptySlots) {
      bestColumns = columns;
      bestEmptySlots = emptySlots;
    }
  }

  return bestColumns;
}
